export default {
  'projects.researchAssistant.titleApp': 'Research Assistant',
  'projects.researchAssistant.titleYou': 'You',
  'projects.researchAssistant.updateInfoMessage': 'You updated the cohort definition',

  'projects.researchAssistant.chatWindow.title': 'Research Assistant (beta)',
  'projects.researchAssistant.chatWindow.modelDropdown.label': 'Version',
  'projects.researchAssistant.chatWindow.inputField.placeholder.isOwner': 'Send a message...',
  'projects.researchAssistant.chatWindow.inputField.placeholder.isNotOwner':
    'Only the cohort owner can submit messages.',
  'projects.researchAssistant.chatWindow.inputField.placeholder.invalidStatus':
    'Cohort is not in a valid state for messaging.',

  'projects.researchAssistant.footer.disclaimer':
    'Research Assistant may make mistakes. Double-check all output.',

  'projects.researchAssistant.suggestedActions.title': 'Suggested actions',
  'projects.researchAssistant.suggestedActions.createConceptGroup':
    'Create {conceptGroupName} concept group',
  'projects.researchAssistant.suggestedActions.createConceptGroupPrompt':
    'Create a concept group for {conceptGroupName}',

  'projects.researchAssistant.conceptGroupReview.message':
    'I\'ve created the "{conceptGroupName}" concept group you requested! Before you can use it in your cohort definition, you\'ll need to review and save it.\n\nClick the link below to open the review modal. There you can also download the concept group, make any edits you want, and re-upload it before saving.',

  'projects.researchAssistant.chatWindow.fileUpload.buttonAriaLabel': 'Upload CSV file',
  'projects.researchAssistant.chatWindow.fileUpload.uploadedMessage':
    '{userPrompt}{newline}📎 Uploaded: {fileName}',
  'projects.researchAssistant.chatWindow.fileUpload.dragRejectTitle': 'Invalid file type or size',
  'projects.researchAssistant.chatWindow.fileUpload.dragActiveTitle': 'Drop your file here',
  'projects.researchAssistant.chatWindow.fileUpload.dragRejectDescription':
    'Allowed: {allowedTypes} (max {maxSizeMB}MB)',
  'projects.researchAssistant.chatWindow.fileUpload.dragActiveDescription':
    '{allowedTypes} files up to {maxSizeMB}MB',
  'projects.researchAssistant.chatWindow.fileUpload.fileTooLarge':
    'File size exceeds {maxSizeMB}MB limit',
  'projects.researchAssistant.chatWindow.fileUpload.invalidFileType':
    'Invalid file type. Allowed types: {allowedTypes}',
  'projects.researchAssistant.chatWindow.fileUpload.uploadFailed': 'Failed to upload file',

  'projects.researchAssistant.mappingResults.reviewLink': 'Review mapping results',

  'projects.researchAssistant.analyticalVariable.message':
    'I\'ve created the analytical variable "{name}" you requested! Click the button below to view its definition, SQL, data preview, and verification details.',
  'projects.researchAssistant.analyticalVariable.viewLink': "View '{name}'",

  'projects.researchAssistant.feedback.tooltipPositive': 'Good response',
  'projects.researchAssistant.feedback.tooltipNegative': 'Bad response',
  'projects.researchAssistant.feedback.commentLabel': 'What went wrong (optional)',
  'projects.researchAssistant.feedback.commentPlaceholder': 'Tell us what could be improved...',
  'projects.researchAssistant.feedback.submitButton': 'Submit feedback',
  'projects.researchAssistant.feedback.successMessage': 'Thanks for your feedback!',
  'projects.researchAssistant.feedback.editTooltip': 'Edit',
  'projects.researchAssistant.feedback.clearRating': 'Remove rating',
};
